/**
 * Type guard for filtering falsy undefined and null values
 * from an array.
 * @example array.filter(isDefined)
 * @param value Array with undefined or null values
 */export function isDefined(value){return value!==null&&value!==undefined;}